import { FC } from 'react';
import { easeInOut, motion } from 'framer-motion';
import { Flex } from '@servicetitan/anvil2';

const dotVariants = {
    bounce: (i: number) => ({
        y: [0, -15, 0],
        transition: {
            duration: 1.2,
            ease: easeInOut,
            repeat: Infinity,
            delay: i * 0.15,
        },
    }),
};

export const Loader: FC = () => {
    return (
        <Flex className="p-block-start-2 m-block-start-3">
            {[0, 1, 2].map(i => (
                <motion.div
                    key={i}
                    custom={i}
                    variants={dotVariants}
                    animate="bounce"
                    style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: '#105BDD',
                    }}
                />
            ))}
        </Flex>
    );
};
